import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47d81370"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "d-flex align-items-center justify-content-center flex-column",
  style: {"min-height":"532px","min-width":"797px"}
}
const _hoisted_2 = ["src"]
const _hoisted_3 = {
  key: 2,
  class: "d-flex justify-content-end w-100",
  style: {"padding-bottom":"0.5rem","padding-top":"1.5rem"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Abbrechen ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x-circle",
  style: {"margin-left":"1rem","font-size":"1.5rem"}
}, null, -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Drucken ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-printer",
  style: {"margin-left":"1rem","font-size":"1.5rem"}
}, null, -1))
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

import {ref, watch} from "vue";
import Spinner from "@/components/Spinner.vue"
import BaseDialog from "@/components/BaseDialog.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  uri: {
    type: String,
    required: true,
    default() {
      return ''
    }
  },
  show: {
    type: Boolean,
    required: true
  }
},
  emits: ["closed", "cleared"],
  setup(__props, { emit }: { emit: ({
  (e: 'closed'):void
  (e: 'cleared'):void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const loadingState = ref<boolean>(false)

const imageHTML = (uri: string):string => {
  return `
    <html>
        <head>
            <link rel="stylesheet" href="${location.protocol}//${location.host}/print.css">
            <scr`+`ipt type="text/javascript">const print = () => { window.print(); window.close(); }</scr`+`ipt>
        </head>
        <body onload="print()">
            <img
              src="${uri}"
            >
        </body>
    </html>`
}

const clearAndClose = () => {
  emit('cleared')
  emit('closed')
}

const printURI = () => {
  const pwa = window.open("about:blank", "_new")
  pwa.document.open()
  pwa.document.write(imageHTML(props.uri))
  pwa.document.close()
  clearAndClose()
}

watch(() => props.show, (val) => {
  if (val) {
    loadingState.value = true
    setTimeout(() => {
      if (props.uri === "") {
        return
      }
      loadingState.value = false
    }, 500)
  }
})

watch(() => props.uri, (val) => {
  if (val !== "" && loadingState.value) {
    loadingState.value = false
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseDialog, {
    show: __props.show,
    onClosed: _cache[0] || (_cache[0] = ($event: any) => (emit('closed')))
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (loadingState.value)
          ? (_openBlock(), _createBlock(Spinner, { key: 0 }))
          : _createCommentVNode("", true),
        (!loadingState.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              id: "img-print-preview",
              src: __props.uri,
              alt: "Collage Print Preview"
            }, null, 8, _hoisted_2))
          : _createCommentVNode("", true),
        (!loadingState.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "button-warn",
                onClick: clearAndClose,
                style: {"margin-right":"1.5rem"}
              }, _hoisted_6),
              _createElementVNode("button", {
                class: "button-primary",
                onClick: printURI
              }, _hoisted_9)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}
}

})